import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Wizard from './../../../../components/wizard';
import { getSteps } from './steps';
import { setProgress } from '../../../../reducers/wizard';

class ClientOnboarding extends React.Component {
    componentDidMount() {
        const { client, setProgress } = this.props;
        const { id, progress } = client;
        setProgress({ entity: 'client', id }, progress);
    }

    render() {
        const { client } = this.props;
        return <Wizard configuration={{ entity: 'client', id: client.id }} getSteps={(controls, progress) => getSteps(controls, progress, this.props)} />;
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    client: state.identity.details
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setProgress: setProgress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientOnboarding);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/client/index.jsx